// Array.prototype.at is missing on Safari <15.4, Chrome <92, Firefox <90.
if (!Array.prototype.at) {
  Object.defineProperty(Array.prototype, 'at', {
    value: function (index: number) {
      const numberIndex = index === undefined ? 0 : Number(index)
      const integerIndex = Number.isNaN(numberIndex) ? 0 : Math.trunc(numberIndex)
      const relativeIndex = integerIndex >= 0 ? integerIndex : this.length + integerIndex
      return relativeIndex >= 0 && relativeIndex < this.length ? this[relativeIndex] : undefined
    },
    writable: true,
    configurable: true,
  })
}
